<template>
  <div class="sessions-table">
    <div class="table">
      <div v-if="mobileMode" class="table__filter-wrp">
        <button
          class="table__filter-btn"
          v-if="mobileMode"
          @click="showFilter = !showFilter"
        >
          <i class="fas fa-filter"></i>
        </button>
      </div>
      <div :class="['row-header', { 'header-show': showFilter }]">
        <el-select
          popper-class="select-discipline-drop"
          v-model="form.discipline"
          @clear="clearDisciplineField"
          clearable
          placeholder="Дисциплина"
          @change="setDiscipline"
        >
          <el-option
            v-for="(item, index) in supportData.disciplineArray"
            :key="index"
            :label="item.name"
            :value="item.did"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="form.group"
          @clear="clearGroupField"
          placeholder="Группа"
          clearable
          @change="setGroup"
        >
          <el-option
            v-for="(item, index) in supportData.filtredData"
            :key="index"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="form.valueSS"
          v-if="mobileMode"
          @clear="clearGroupField"
          placeholder="Начало сессии"
          clearable
          @change="sortStartSession"
        >
          <el-option
            v-for="(item, index) in supportData.filterStartSession"
            :key="index"
            :label="item.title"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          v-model="form.valueSE"
          v-if="mobileMode"
          @clear="clearGroupField"
          placeholder="Конец сессии"
          clearable
          @change="sortEndSession"
        >
          <el-option
            v-for="(item, index) in supportData.filterStartSession"
            :key="index"
            :label="item.title"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="cell-sort" v-if="!mobileMode">
          <span>Начало сессии</span>
          <div>
            <button class="cell-sort__btn-down" @click="sortStartSession(0)">
              <i class="el-icon-caret-top"></i>
            </button>
            <button class="cell-sort__btn-up" @click="sortStartSession(1)">
              <i class="el-icon-caret-bottom"></i>
            </button>
          </div>
        </div>
        <div class="cell-sort" v-if="!mobileMode">
          <span>Конец сессии</span>
          <div>
            <button class="cell-sort__btn-down" @click="sortEndSession(0)">
              <i class="el-icon-caret-top"></i>
            </button>
            <button class="cell-sort__btn-up" @click="sortEndSession(1)">
              <i class="el-icon-caret-bottom"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="table__content">
        <div
          class="row"
          v-for="(group, index) of supportData.filtredData"
          :key="index"
        >
          <span class="discipline__name">{{ group.discipline }}</span>
          <span class="group__name">{{
            mobileMode ? `Группа: ${group.name}` : group.name
          }}</span>
          <span class="data__session-start">{{
            mobileMode
              ? `Старт сессии: ${setData(group.zs)}`
              : setData(group.zs)
          }}</span>
          <span class="data__session-end">{{
            mobileMode
              ? `Конец сессии: ${setData(group.ze)}`
              : setData(group.ze)
          }}</span>
        </div>
        <div class="row-empty" v-if="!supportData.filtredData.length">
          <span>Нет данных</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      showFilter: false,
      form: {
        discipline: "",
        group: "",
        valueSS: "",
        valueSE: "",
      },
      supportData: {
        allData: [],
        filtredData: [],
        filterStartSession: [
          {
            title: "По возрастанию",
            value: 0,
          },
          {
            title: "По Убыванию",
            value: 1,
          },
        ],
        filterEndSession: [
          {
            title: "По возрастанию",
            value: 0,
          },
          {
            title: "По Убыванию",
            value: 1,
          },
        ],
      },
    };
  },
  computed: {
    mobileMode() {
      return this.$store.state.mobileMode;
    },
  },

  methods: {
    clearGroupField() {
      if (this.form.discipline) {
        this.setDiscipline(this.form.discipline);
      } else {
        this.supportData.filtredData = this.supportData.allData;
      }
    },
    clearDisciplineField() {
      this.supportData.filtredData = this.supportData.allData;
    },
    setDiscipline(value) {
      this.supportData.filtredData = this.supportData.allData.filter(
        (el) => el.did === value
      );
    },
    setGroup(value) {
      this.supportData.filtredData = this.supportData.filtredData.filter(
        (el) => el.id === value
      );
    },
    setData(value) {
      return this.globalFunctions.dateCorrector(value);
    },
    getDisciplineName(value) {
      return this.supportData.disciplineArray.find((el) => el.did === value)
        .name;
    },
    convertDateToNumber(value) {
      return value ? Number(value.split(" ")[0].split("-").join("")) : "";
    },
    sortStartSession(value) {
      this.supportData.filtredData.sort((a, b) => {
        if (value) {
          return (
            this.convertDateToNumber(a.zs) - this.convertDateToNumber(b.zs)
          );
        } else {
          return (
            this.convertDateToNumber(b.zs) - this.convertDateToNumber(a.zs)
          );
        }
      });
    },
    sortEndSession(value) {
      this.supportData.filtredData.sort((a, b) => {
        if (value) {
          return (
            this.convertDateToNumber(a.ze) - this.convertDateToNumber(b.ze)
          );
        } else {
          return (
            this.convertDateToNumber(b.ze) - this.convertDateToNumber(a.ze)
          );
        }
      });
    },
  },
  mounted() {
    this.axios.get("/api/sessions").then((res) => {
      let testArray = [];
      let test = res.data.data;
      test.forEach((element) => {
        element.groups.forEach((el) => {
          el.discipline = element.name;
          el.did = element.did;
        });
      });
      test.forEach((element) => {
        testArray.push(element.groups);
      });
      this.supportData.allData = testArray.flat();
      this.supportData.filtredData = testArray.flat();
      this.supportData.disciplineArray = res.data.data;
    });
  },
};
</script>

<style lang="scss">
.sessions-table {
  overflow: hidden;
  width: 100%;
  height: 100%;
  .table {
    overflow: hidden;
    display: grid;
    grid-template-rows: max-content 1fr;
    color: $secondary-text-clr;
    width: 100%;
    height: 100%;
    position: relative;
    .el-icon-circle-close {
      font-size: 18px !important;
      color: $brand-clr-1 !important;
    }
  }
  .table__filter-wrp {
    padding: 5px 0;
    position: absolute;
    z-index: 10;
    right: 0;
    top: 0;
    width: 100%;
    background-color: $basic-white;
    text-align: right;
  }
  .table__filter-btn {
    i {
      font-size: 30px;
      color: $brand-clr-1;
    }
  }
  .row-header {
    transition-duration: 0.3s;
    transition-property: transform;
    width: 100%;
    border-bottom: 1px solid $placeholder-text-clr;
    display: grid;
    grid-template-columns: 3fr 1fr 1fr 1fr;
    column-gap: 20px;
    justify-items: center;
    align-items: center;
    padding: 10px;
    background-color: $basic-white;
  }
  .table__content {
    width: 100%;
    overflow-y: auto;
    height: 100%;
  }
  .row {
    padding: 10px;
    width: 100%;
    display: grid;
    column-gap: 20px;
    grid-template-columns: 3fr 1fr 1fr 1fr;
    grid-template-areas: "dname gname ssdate sedate";
    border-bottom: 1px solid $base-border-clr;
    span {
      text-align: center;
    }
  }
  .row-empty {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .cell-sort {
    column-gap: 8px;
    display: grid;
    grid-template-columns: 1fr min-content;
    align-items: center;
  }
  .cell-sort__btn-down,
  .cell-sort__btn-up {
    padding: 0;
    width: 20px;
    height: 13px;
    color: $secondary-text-clr;
    display: block;
    i {
      font-size: 20px;
      line-height: 0;
    }
    &:hover {
      color: $brand-clr-1;
    }
  }
  .discipline__name {
    grid-area: dname;
  }
  .group__name {
    grid-area: gname;
  }
  .data__session-start {
    grid-area: ssdate;
  }
  .data__session-end {
    grid-area: sedate;
  }
}
@media (max-width: 800px) {
  .sessions-table {
    .table {
      overflow-y: hidden;
    }
    .table__content {
      padding: 60px 10px 0 10px;
    }
    .row {
      row-gap: 10px;
      border-radius: 10px;
      grid-template-columns: 1fr;
      -webkit-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
      -moz-box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
      box-shadow: 0px 2px 5px 0px rgba(50, 50, 50, 0.25);
      margin-bottom: 20px;
      grid-template-areas:
        "ssdate"
        "sedate"
        "gname"
        "dname";
      .discipline__name {
        text-align: left;
      }
    }
    .row-header {
      padding-top: 60px;
      grid-template-columns: 1fr;
      row-gap: 20px;
      transform: translateY(-100%);
    }
    .header-show {
      transform: translateY(0);
    }
    .data__session-start,
    .data__session-end,
    .group__name {
      justify-self: start;
    }
  }
  .select-discipline-drop {
    max-width: 200px;
  }
}
</style>